module.exports = __webpack_public_path__ + "static/media/background-123.e793d2f3.jpg";